import React, { useEffect, useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { addCompany } from "../../../../../../store/actions/company";
import { useDispatch } from "react-redux";

const DuplicateCompanyModal = ({ preview, previewHandler, selectedCompany }) => {
  const [duplicateLoader, setduplicateLoader] = useState(false);
  const [form] = Form.useForm();
  const { http } = global.services;
  const dispatch = useDispatch();

  const duplicateHandler = (values) => {
    setduplicateLoader(true);
    http
      .post(`duplicate-company/${selectedCompany.id}`, {
        company_name: values.company_name,
      })
      .finally(() => setduplicateLoader(false))
      .then(({ data }) => {
        toast.success("Company duplicated successfully");
        dispatch(addCompany(data));
        previewHandler();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  useEffect(() => {
    if (preview) {
      form.resetFields();
      form.setFieldsValue({
        company_name: selectedCompany?.company_name || "",
      });
    }
  }, [preview, selectedCompany]);

  return (
    <Modal
      visible={preview}
      centered
      width={600}
      className="delete-company-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Duplicate Company</h2>
      <p>
        This will create a new company using the selected company’s details. Enter a new
        name below.
      </p>
      <Form form={form} className="customize-form" onFinish={duplicateHandler}>
        <label htmlFor="company-field">Company name</label>
        <Form.Item
          name="company_name"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Company name is required",
            },
            {
              max: 100,
              message: "Company name cannot exceed 100 characters",
            },
          ]}
        >
          <Input id="company-field" type="text" placeholder="Enter company name" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit">
            {duplicateLoader ? <BeatLoader size={8} color="#fff" /> : "Duplicate Company"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default DuplicateCompanyModal;
